import { useStripeSessionFeedback } from "../../hooks/useStripeSessionFeedback";
import { CircularProgress, Modal } from "../../../../components";
import { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Stack, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";

export const PaymentStatusModal = () => {
  const [open, setOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect");
  const [buttonText, setButtonText] = useState(
    redirect ? "Redirecting back..." : "Close",
  );

  const { status, loading } = useStripeSessionFeedback();

  const handleClose = () => {
    if (!redirect) setOpen(false);
  };

  const renderTitle = () => {
    if (loading) {
      return "Processing payment details";
    }

    switch (status) {
      case "idle":
        return "";
      case "paid":
        return "Payment Successful";
      case "downgrade":
        return "Downgrade Successful";
      case "upgrade":
        return "Upgrade Successful";
      case "unpaid":
        return "Payment Failed";
      case "error":
      default:
        return "Processing Failed";
    }
  };

  const renderDescription = () => {
    if (loading) {
      return "Please wait while we process your payment details";
    }

    switch (status) {
      case "idle":
        return "";
      case "paid":
        return "Your payment has been successfully processed";
      case "downgrade":
        return "Your plan downgrade has scheduled successfully";
      case "upgrade":
        return "Your plan has been successfully upgraded";
      case "unpaid":
        return "Your payment has failed";
      case "error":
      default:
        return "Failed to process your payment details";
    }
  };

  const renderIcon = () => {
    if (loading) {
      return <CircularProgress size="lg" />;
    }

    switch (status) {
      case "idle":
        return null;
      case "downgrade":
      case "upgrade":
      case "paid":
        return <CheckCircleIcon color="success" />;
      case "error":
      case "unpaid":
      default:
        return <CancelIcon color="error" />;
    }
  };

  useEffect(() => {
    setOpen(false);
  }, [status, loading]);

  return (
    <Modal
      open={open}
      buttons={[
        {
          type: "secondary",
          text: buttonText,
          props: { onClick: handleClose, disabled: !!redirect },
        },
      ]}
      buttonAlignment="center"
      disableAutoFocus
    >
      <Stack direction="row" alignItems="center" gap={1}>
        {renderIcon()}
        <Typography fontSize={18} fontWeight={500}>
          {renderTitle()}
        </Typography>
      </Stack>
      <Typography fontSize={14} fontWeight={400}>
        {renderDescription()}
      </Typography>
    </Modal>
  );
};
